import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { APP_NAME, IS_APP_PRODUCTION } from "../constants/app";

const characterList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const CookieList = ["accessToken", "refreshToken"];

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export function getCurrentUrl(location) {
	return location.pathname.split(/[?#]/)[0];
}
export function checkIsActive(location, url) {
	const current = getCurrentUrl(location);
	const currentSplit = current.split("/");

	if (!current || !url) {
		return false;
	}

	if (current === url) {
		return true;
	}

	if (url.split("/").every((urlPiece) => currentSplit.includes(urlPiece))) {
		return true;
	}

	return false;
}

export function generateCookiesName() {
	let secretCode = 10;
	for (let i = 0; i < APP_NAME.length; i++) {
		secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
	}

	secretCode = Math.round(secretCode / APP_NAME.length);
	let GeneratedCookiesName = {};
	CookieList.forEach((cookie) => {
		let tempCookieString = "";
		for (let j = 0; j < cookie.length; j++) {
			let charCode = Math.floor((cookie.charCodeAt(j) * characterList.length * cookie.length) / secretCode);
			charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
			tempCookieString += characterList.charAt(Math.floor(charCode));
		}

		GeneratedCookiesName[cookie] = tempCookieString;
	});
	return GeneratedCookiesName;
}
export function generatePredictableUniqueKeyName(key) {
	let secretCode = 10;
	for (let i = 0; i < APP_NAME.length; i++) {
		secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
	}

	secretCode = Math.round(secretCode / APP_NAME.length);
	let uniqueKeyString = "";
	for (let j = 0; j < key.length; j++) {
		let charCode = Math.floor((key.charCodeAt(j) * characterList.length * key.length) / secretCode);
		charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
		uniqueKeyString += characterList.charAt(Math.floor(charCode));
	}
	return uniqueKeyString;
}
export const generatedCookies = generateCookiesName();
export const storage = IS_APP_PRODUCTION
	? {
			getToken: () => Cookies.get(generatedCookies.accessToken) && CryptoJS.AES.decrypt(Cookies.get(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
			setToken: (token) =>
				Cookies.set(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString(), { secure: true, path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}`, expires: 0.5 }),
			clearToken: () => Cookies.remove(generatedCookies.accessToken, { path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}` }),
			setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
			getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
	  }
	: {
			getToken: () =>
				window.localStorage.getItem(generatedCookies.accessToken) &&
				CryptoJS.AES.decrypt(window.localStorage.getItem(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
			setToken: (token) => window.localStorage.setItem(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString()),
			clearToken: () => window.localStorage.removeItem(generatedCookies.accessToken),
			setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
			getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
	  };
export const toCapitalize = (word = "") => {
	return word[0].toUpperCase() + word.slice(1).toLowerCase();
};

export const toCamelize = (str) => {
	return str
		.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
			return index === 0 ? word.toLowerCase() : word.toUpperCase();
		})
		.replace(/\s+/g, "");
};

export const formatToCurrency = (num) => {
	let formatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",

		//These options are needed to round to whole numbers if that's what you want.
		//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
		//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
	});
	return formatter.format(num);
};
export const parseToNumber = (stringNumber, locale = "en-US") => {
	let thousandSeparator = Intl.NumberFormat(locale)
		.format(11111)
		.replace(/\p{Number}/gu, "");
	let decimalSeparator = Intl.NumberFormat(locale)
		.format(1.1)
		.replace(/\p{Number}/gu, "");

	return parseFloat(
		stringNumber
			.substring(1)
			.replace(new RegExp("\\" + thousandSeparator, "g"), "")
			.replace(new RegExp("\\" + decimalSeparator), ".")
	);
};

export const toastGenerator = ({ payrollConfirmAlert = false, status = "success", message = "" }) => {
	const toastTitle = {
		success: () => `Information`,
		warning: () => `Information`,
		error: () => `Something went wrong`,
	};

	const toastDescription = {
		success: () => (message ? message : `Data has been saved.`),
		warning: () => (message ? `${message}` : `Unable to save data.`),
		error: () => `Please try again.`,
	};

	return {
		title: toastTitle[status](),
		description: toastDescription[status](),
		fontSize: "sm",
		status: status,
		variant: "subtle",
		duration: payrollConfirmAlert ? 80000 : 2000,
		position: "top",
		isClosable: true,
	};
};

export function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

export const isValidDate = (value) => {
	return value && value instanceof Date && !isNaN(value) ? value : null;
};

export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
